// src/redux/sagas/appInitializationSaga.ts
import { fork, put } from 'redux-saga/effects';
import { SiteContent } from '../../types/siteContent';
import { fetchTpnConfigRequest } from '../slices/tpnConfigSlice';
// import { fetchTableAvailabilityRequest } from '../slices/tableAvailabilitySlice';
import { fetchMenuItemsRequest } from '../slices/menuItemsSlice';
import { fetchModifiersRequest } from '../slices/modifiersSlice';
import { preloadRequiredWidgets } from '../../utils/widgetPreloader';

/**
 * Initializes all background tasks after site content is loaded
 * This includes: TPN config, table availability, menu items, modifiers, and widget preloading
 */
export function* initializeAppBackgroundTasks(siteContentData: SiteContent): Generator<any, void, any> {
  try {

     // 1. Preload essential widgets for better performance
    const widgets = siteContentData?.widgets || [];
    const pages = siteContentData?.pages || {};
    yield fork(preloadRequiredWidgets, widgets, pages);

    // 2. Load TPN configuration for payment processing
    yield put(fetchTpnConfigRequest());
    
    // 3. Load menu items and modifiers (needed for popular widgets on HomePage)
    yield put(fetchMenuItemsRequest());
    yield put(fetchModifiersRequest());

    // // 4. Load table availability for today's date
    // const currentDate = new Date().toISOString().split('T')[0];
    // yield put(fetchTableAvailabilityRequest({ date: currentDate }));
    
  } catch (error) {
    // Silently handle background task errors to avoid blocking the main app
    console.warn('Background initialization task failed:', error);
  }
}
